const STATUS_MAP = {
  draft: { label: "Draft", cls: "bg-secondary text-muted-foreground" },
  pending: { label: "Menunggu Review", cls: "bg-amber-100 text-amber-700" },
  published: { label: "Aktif", cls: "bg-emerald-100 text-emerald-700" },
  rejected: { label: "Ditolak", cls: "bg-red-100 text-red-700" },
  inactive: { label: "Nonaktif", cls: "bg-gray-200 text-gray-600" },
};

export default function PropertyStatusBadge({ status, testid }) {
  const s = STATUS_MAP[status] || STATUS_MAP.draft;
  return (
    <span
      data-testid={testid || "property-status-badge"}
      className={`inline-block text-xs font-semibold px-2.5 py-1 rounded-full ${s.cls}`}
    >
      {s.label}
    </span>
  );
}

export const PROPERTY_STATUS_LABELS = {
  draft: "Draft",
  pending: "Menunggu Review",
  published: "Aktif",
  rejected: "Ditolak",
  inactive: "Nonaktif",
};

export const PROPERTY_TYPE_LABELS = {
  kos: "Kos",
  apartemen: "Apartemen",
  kontrakan: "Kontrakan",
  coliving: "Co-living",
  lainnya: "Lainnya",
};

export const GENDER_LABELS = {
  putra: "Putra",
  putri: "Putri",
  campur: "Campur",
  tidak_berlaku: "Tidak berlaku",
};
